import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { GeneralService } from '../../../services/formulacion/general.service';
import { TraspasoService } from '../../../services/formulacion/traspaso.service';
import { environment } from '../../../../environments/environment';
import { UtilHelper } from '../../../_helpers/util';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-traspasos-juridica',
  templateUrl: './traspasos-juridica.component.html',
  styleUrls: [],
  providers: [GeneralService, TraspasoService]
})
export class TraspasosJuridicaComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxScrollViewComponent) scrollView: DxScrollViewComponent;
  tipo_agregacion_id: number = 1;
  esNuevaObs: boolean = false;
  dataResourceObs: any[];
  scrollByContent = true;
  scrollByThumb = true;
  estados: any[];
  dataResource: any[];
  popupVisibleObs: boolean = false;
  popupVisibleRet: boolean = false;
  popupVisibleChk: boolean = false;
  popupVisibleT: boolean = false;
  baseUrl: string;
  traspaso_id: number;
  intervencion_id: number;
  estado_id: number;
  model: any;
  hasError: any;
  fInforme: Date;
  fResolucion: Date;
  rol: number = 0;
  traspaso: any = {};
  modelA: any = { traspaso_destino_id: '', usuario_asignado_id: '' };
  ua_id: boolean = false;
  update: boolean = false;
  title: string = '';
  clicked: boolean = false;
  tipoSeg: any = { id: '', descripcion: '' };
  constructor(private _gs: GeneralService, private _trs: TraspasoService) {
    this.baseUrl = environment.apiEndpoint;
    this.intervencion_id = 0;
    this.estado_id = 25;
    this.tipo_agregacion_id = 1;
    this.getTraspasos();
    this.getEstadosTByUsuario();
    this.clearModel();
    this.clearErrors();
    this.getEstadoObservado();
    let u = JSON.parse(localStorage.getItem('u'));
    if (u != null)
      this.rol = u.rol;
  }

  ngOnInit() {
  }

  clearModel() {
    this.model = { id: '', nro_informe: '', fecha_informe: '', nro_resolucion: '', fecha_resolucion: '', justificacion: '' };
  }

  clearErrors() {
    this.hasError = { nro_informe: false, fecha_informe: false, nro_resolucion: false, fecha_resolucion: false, descripcion: false };
  }

  getEstadoObservado() {
    this.tipoSeg = [{ id: 30, descripcion: 'Observado DGAJ' }];
  }

  getTraspasos() {
    if (this.intervencion_id != undefined && this.intervencion_id != null) {
      this._trs.getTraspasosPorAprobar(this.intervencion_id, this.estado_id, this.tipo_agregacion_id).subscribe((response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResource = result.data;
        } else {
          this.dataResource = [];
        }
      },
        (error) => { console.log('Error', error); });
    } else {
      this.intervencion_id = 0;
    }
  }

  refreshDataGrid(e) {
    this.estado_id = e.value;    
    this.getTraspasos();
    this.dataGrid.instance.refresh();
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalReturn(id: number) {
    this.model.id = id;
    this.popupVisibleRet = true;
  }

  returnTraspaso() {//Cambiar la ruta al que no existe todavia
    this._trs.putObservaTraspasoPApD(this.model).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getTraspasos();
          this.popupVisibleRet = false;
        }
      },
      error => { console.log('Error', error); });
  }

  showModalCheck(id: number) {
    this.title = 'APROBAR TRASPASO';
    this.clearModel();
    this.model.id = id;
    this.popupVisibleChk = true;
    this.update = false;
  }

  aprobarTraspaso() {
    this.clearErrors();

    if (this.validateAprueba(this.model)) {
      this.clicked = true;
      this.model.fecha_informe = this.convertDate(this.fInforme);
      this.model.fecha_resolucion = this.convertDate(this.fResolucion);
      if (this.update) {
        this._trs.putTraspasoAprobadoJuridica(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getTraspasos();
              this.popupVisibleChk = false;
              this.clicked = false;
              toastr.success('Traspaso modificado exitosamente.');
            }
            this.clicked = false;
          });
      }
      else {
        this._trs.putApruebaJuridica(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.popupVisibleChk = false;
              this.clicked = false;
              this.getTraspasos();
              toastr.success('Traspaso aprobado exitosamente.');
            } else if (result.status == 201) {
              this.popupVisibleChk = false;
              this.clicked = false;
              this.getTraspasos();
              toastr.success('El traspaso ya fué aprobado');
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  validateAprueba(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.nro_informe, 'text')) {
      this.hasError.nro_informe = true; res = false;
    }
    if (!UtilHelper.validator(data.nro_resolucion, 'text')) {
      this.hasError.nro_resolucion = true; res = false;
    }
  
    return res;
  }

  getEstadosTByUsuario() {
    this._trs.getEstadosTByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estados = result.data;
        }
        else { this.estados = []; }
      },
      (error) => { console.log('Error', error); });
  }

  convertDate(date: Date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    let nd = dd.toString();
    let nm = mm.toString();
    var yyyy = date.getFullYear(); if (dd < 10) { nd = '0' + dd } if (mm < 10) { nm = '0' + mm }
    return nd + '/' + nm + '/' + yyyy;
  }

  showModalAsig(id: number) {
    this._trs.getAsignaJuridicaByTId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.traspaso = result.data; }
        else { this.traspaso = {}; }
      });
    this.modelA.traspaso_destino_id = id;
    this.modelA.usuario_asignado_id = '';
    this.popupVisibleT = true;
  }

  asignarTraspaso() {
    this.clicked = true;
    this.ua_id = false;
    this.modelA.usuario_asignado_id = this.modelA.usuario_asignado_id == null ? '' : this.modelA.usuario_asignado_id;
    if (this.modelA.usuario_asignado_id != '') {
      this._trs.postAsignaJuridica(this.modelA).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getTraspasos();
            this.popupVisibleT = false;
            this.clicked = false;
            toastr.success('Trámite asignado exitosamente.');
          }
          else if (result.status == 201) {
            this.popupVisibleT = false;
            this.clicked = false;
            toastr.warning("Existe otra asignación realizada anteriormente");
          }

        },
        error => { console.log('Error', error); });
    }
    else {
      this.modelA.usuario_asignado_id = '';
      this.ua_id = true;
    }
  }

  showModalEdit(id: number) {
    this.title = 'EDITAR TRASPASO APROBADO';
    this.fInforme = new Date();
    this.fResolucion = new Date();
    this.clearModel();
    this.update = false;
    this._trs.getArobadoJuridica(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleChk = true;
          this.model = result.data;
          var dd = result.data.fecha_informe.toString().split('-');
          this.fInforme = new Date(dd[0], parseInt(dd[1]) - 1, dd[2]);
          var dd = result.data.fecha_resolucion.toString().split('-');
          this.fResolucion = new Date(dd[0], parseInt(dd[1]) - 1, dd[2]);
          this.update = true;
        }
      });
  }

  observarTraspaso() {
    this.model.tipo_traspaso = 'D';
    this.model.estado_id = 30;
    if (this.valid()) {
      this.clicked = true;
      this._trs.putSeguimientoGral(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getTraspasos();
            this.popupVisibleObs = false;
            toastr.success('Operación realizada exitosamente.');
          }
          this.clicked = false;
        },
        error => { console.log('Error', error); });
    }
  }

  valid() {
    let res = true;
    if (!UtilHelper.validator(this.model.estado_id, 'integer')) {
      this.hasError.estado_id = true; res = false;
    }
    if (!UtilHelper.validator(this.model.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    return res;
  }

  showModalObservar(id: number) {
    this.model.id = id;    
    this.model.descripcion = '';
    this.popupVisibleObs = true;
    this.getObservacionesLista();
  }

  getObservacion() {
    if ((this.model.estado_id != 0)) {      
      this.esNuevaObs = false;
      this.model.descripcion = '';
      this.model.observacion_id = 0;
      this.model.estado_id = 30;
    }

  }

  getDescribirObservacion(e: any) {
    var esNueva = this.dataResourceObs.filter(o => o.id == e.value).map(o => o.descripcion).toString();
    if (esNueva == 'Otro') {
      this.esNuevaObs = true;
      this.model.descripcion = '';
    }

    else {
      this.esNuevaObs = false;
      this.model.descripcion = esNueva;
    }

  }

  getObservacionesLista() {
    this._gs.getObservaciones('FUS').subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceObs = result.data;
        }
        else { this.dataResourceObs = []; }
      },
      (error) => { console.log('Error', error); });
  }
}
